// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-selection {
  display: flex;
  cursor: pointer;
}

.bracket-column {
  display: flex;
  flex-direction: column;
}

.bracket-column-2 .bracket-box {
  margin-top: 142px;
}

.bracket-column-2 .bracket-box:first-child {
  margin-top: 55px;
}

.bracket-column-4 .bracket-box {
  margin-top: 56px;
  margin-bottom: 10px !important;
}

.region-title {
  color: #CECECE;
  text-align: center;
  font-family: Inter;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.champion-box {
  width: 123px;
  height: 118px;
  border-radius: var(--1, 8px) var(--1, 8px) var(--none, 0px) var(--none, 0px);
  border-top: 1px solid #6D6D6D;
  border-right: 1px solid #6D6D6D;
  border-left: 1px solid #6D6D6D;
  background: #FFF;
}

.place-holder-team {
  border-radius: 2px;
  background: #B3B3B3;
  width: 89px;
  height: 89px;
  margin: 0 auto;
  margin-top: 15px;
}

.champion-title {
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: var(--none, 0px) var(--none, 0px) var(--1, 8px) var(--1, 8px);
  border-right: 1px solid #6D6D6D;
  border-bottom: 1px solid #6D6D6D;
  border-left: 1px solid #6D6D6D;
  background: #F2F2F2;
  display: flex;
  width: 123px;
  height: 29.4px;
  padding: var(--1, 8px);
  justify-content: center;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
}

.tournament-bracket {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 20px;
  position: relative;
}
.tournament-bracket .bracket-quadrant-left-top {
  grid-area: 1/1/2/2;
}
.tournament-bracket .bracket-quadrant-right-top {
  grid-area: 1/2/2/3;
}
.tournament-bracket .bracket-quadrant-right-top .bracket {
  flex-direction: row-reverse;
}
.tournament-bracket .bracket-quadrant-left-bottom {
  grid-area: 2/1/3/2;
}
.tournament-bracket .bracket-quadrant-right-bottom {
  grid-area: 2/2/3/3;
}
.tournament-bracket .bracket-quadrant-right-bottom .bracket {
  flex-direction: row-reverse;
}
.tournament-bracket .bracket-column-3 .line-end {
  width: 16px;
  height: 56px;
  margin-top: 42px;
}
.tournament-bracket .bracket-column-4 .line-beginning {
  width: 16px;
  border-bottom: 1px solid #6D6D6D;
  height: 46px;
}
.tournament-bracket .bracket-column-4 .line-end {
  width: 16px;
  border-bottom: 1px solid #6D6D6D;
  height: 46px;
}
.tournament-bracket .final-four {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.tournament-bracket .bracket-quadrant-right-bottom .bracket .bracket-column-3 > div:nth-child(even) .line-end {
  display: none;
}
.tournament-bracket .bracket-quadrant-right-bottom .bracket .bracket-column-3 > div:nth-child(even) .line-beginning {
  width: 16px;
  border-bottom: 1px solid #6D6D6D;
  border-left: 1px solid #6D6D6D;
  height: 56px;
  margin-top: -87px;
}
.tournament-bracket .bracket-quadrant-right-bottom .bracket .bracket-column-3 > div:nth-child(odd) .line-end {
  display: none;
}
.tournament-bracket .bracket-quadrant-right-bottom .bracket .bracket-column-3 > div:nth-child(odd) .line-beginning {
  width: 16px;
  border-top: 1px solid #6D6D6D;
  border-left: 1px solid #6D6D6D;
  height: 56px;
  margin-top: 21px;
}
.tournament-bracket .bracket-quadrant-right-top .bracket .bracket-column-3 > div:nth-child(even) .line-end {
  display: none;
}
.tournament-bracket .bracket-quadrant-right-top .bracket .bracket-column-3 > div:nth-child(even) .line-beginning {
  width: 16px;
  border-bottom: 1px solid #6D6D6D;
  border-left: 1px solid #6D6D6D;
  height: 56px;
  margin-top: -87px;
}
.tournament-bracket .bracket-quadrant-right-top .bracket .bracket-column-3 > div:nth-child(odd) .line-end {
  display: none;
}
.tournament-bracket .bracket-quadrant-right-top .bracket .bracket-column-3 > div:nth-child(odd) .line-beginning {
  width: 16px;
  border-top: 1px solid #6D6D6D;
  border-left: 1px solid #6D6D6D;
  height: 56px;
  margin-top: 21px;
}
.tournament-bracket .bracket-quadrant-left-top .bracket .bracket-column-3 > div:nth-child(even) .line-end {
  width: 16px;
  border-bottom: 1px solid #6D6D6D;
  border-right: 1px solid #6D6D6D;
  height: 56px;
  margin-top: -87px;
}
.tournament-bracket .bracket-quadrant-left-top .bracket .bracket-column-3 > div:nth-child(even) .line-beginning {
  display: none;
}
.tournament-bracket .bracket-quadrant-left-top .bracket .bracket-column-3 > div:nth-child(odd) .line-end {
  width: 16px;
  border-top: 1px solid #6D6D6D;
  border-right: 1px solid #6D6D6D;
  height: 56px;
  margin-top: 21px;
}
.tournament-bracket .bracket-quadrant-left-top .bracket .bracket-column-3 > div:nth-child(odd) .line-beginning {
  display: none;
}
.tournament-bracket .bracket-quadrant-left-bottom .bracket .bracket-column-3 > div:nth-child(even) .line-end {
  width: 16px;
  border-bottom: 1px solid #6D6D6D;
  border-right: 1px solid #6D6D6D;
  height: 56px;
  margin-top: -87px;
}
.tournament-bracket .bracket-quadrant-left-bottom .bracket .bracket-column-3 > div:nth-child(even) .line-beginning {
  display: none;
}
.tournament-bracket .bracket-quadrant-left-bottom .bracket .bracket-column-3 > div:nth-child(odd) .line-end {
  width: 16px;
  border-top: 1px solid #6D6D6D;
  border-right: 1px solid #6D6D6D;
  height: 56px;
  margin-top: 21px;
}
.tournament-bracket .bracket-quadrant-left-bottom .bracket .bracket-column-3 > div:nth-child(odd) .line-beginning {
  display: none;
}
.tournament-bracket .bracket-column-6 div .line-beginning {
  width: 16px;
  border-bottom: 1px solid #6D6D6D;
  height: 0;
  margin-bottom: 21px;
}
.tournament-bracket .bracket-column-6 div .line-end {
  width: 16px;
  border-bottom: 1px solid #6D6D6D;
  height: 0;
  margin-bottom: 21px;
}`, "",{"version":3,"sources":["webpack://./src/components/bracketEvents/bracketStyles/marchMadnessBracket.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;AACJ;;AACA;EACI,aAAA;EACA,sBAAA;AAEJ;;AA6BA;EACI,iBAAA;AA1BJ;;AA6BA;EACI,gBAAA;AA1BJ;;AAqCA;EACI,gBAAA;EACA,8BAAA;AAlCJ;;AAqCA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlCJ;;AAqCA;EACI,YAAA;EACA,aAAA;EACA,4EAAA;EACA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,gBAAA;AAlCJ;;AAqCA;EACI,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAlCJ;;AAqCA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4EAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;AAlCJ;;AAqCA;EACI,aAAA;EACA,8BAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;AAlCJ;AAoCI;EACI,kBAAA;AAlCR;AAsCI;EACI,kBAAA;AApCR;AA+CI;EACI,2BAAA;AA7CR;AAgDI;EACI,kBAAA;AA9CR;AAiDI;EACI,kBAAA;AA/CR;AAoDI;EACI,2BAAA;AAlDR;AA0DI;EACI,WAAA;EAGA,YAAA;EACA,gBAAA;AA1DR;AA6DI;EACI,WAAA;EACA,gCAAA;EACA,YAAA;AA3DR;AA6DI;EACI,WAAA;EACA,gCAAA;EACA,YAAA;AA3DR;AA6DI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AA3DN;AA+DY;EACE,aAAA;AA7Dd;AA+DY;EACI,WAAA;EACA,gCAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;AA7DhB;AA8DY;EACI,aAAA;AA5DhB;AA8DY;EACI,WAAA;EACA,6BAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;AA5DhB;AAkEY;EACE,aAAA;AAhEd;AAkEY;EACI,WAAA;EACA,gCAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;AAhEhB;AAiEY;EACI,aAAA;AA/DhB;AAiEY;EACI,WAAA;EACA,6BAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;AA/DhB;AAqEY;EACI,WAAA;EACA,gCAAA;EACA,+BAAA;EACA,YAAA;EACA,iBAAA;AAnEhB;AAqEY;EACI,aAAA;AAnEhB;AAoEY;EACI,WAAA;EACA,6BAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;AAlEhB;AAoEY;EACI,aAAA;AAlEhB;AAwEY;EACI,WAAA;EACA,gCAAA;EACA,+BAAA;EACA,YAAA;EACA,iBAAA;AAtEhB;AAwEY;EACI,aAAA;AAtEhB;AAuEY;EACI,WAAA;EACA,6BAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;AArEhB;AAuEY;EACI,aAAA;AArEhB;AA0EQ;EACI,WAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AAxEZ;AA2EQ;EACI,WAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AAzEZ","sourcesContent":[".team-selection{\n    display: flex;\n    cursor: pointer;\n}\n.bracket-column {\n    display: flex;\n    flex-direction: column;\n}\n\n.bracket-box{\n    // width:263px !important;\n}\n\n//   .bracket-box {\n//     margin-bottom: 32px; /* Adjust the space between the boxes in the first column */\n//   }\n\n//   /* Target the second column */\n//   .bracket .bracket-column:nth-child(2) {\n//     align-self: flex-start; /* Align the column to the start of the flex container */\n//   }\n\n//   /* Adjust the top margin of the boxes in the second column */\n//   .bracket .bracket-column:nth-child(2) .bracket-box {\n//     margin-top: 64px; /* Half the total height of two boxes in the first column, including their margin */\n//     margin-bottom: 0; /* Remove bottom margin for boxes in the second column */\n//   }\n\n//   /* Remove extra top margin from the first box of the second column */\n//   .bracket .bracket-column:nth-child(2) .bracket-box:first-child {\n//     margin-top: 16px; /* Adjust this value based on your layout. It should be around half of the margin-bottom of the first column boxes */\n//   }\n\n//   /* Since we've removed the bottom margin from the second column boxes, we might want to add a bottom margin to the last box of the second column if needed */\n//   .bracket .bracket-column:nth-child(2) .bracket-box:last-child {\n//     margin-bottom: 32px; /* Same as the margin between boxes in the first column, if needed */\n//   }\n.bracket-column-2 .bracket-box {\n    margin-top:142px;\n}\n\n.bracket-column-2 .bracket-box:first-child {\n    margin-top:55px;\n}\n\n.bracket-column-3 .bracket-box {\n    // margin-top: 32px;\n}\n\n.bracket-column-3 .bracket-box:first-child {\n    // margin-top:166px;\n}\n\n.bracket-column-4 .bracket-box {\n    margin-top: 56px; //WILL BE 385px\n    margin-bottom: 10px !important;\n}\n\n.region-title {\n    color: #CECECE;\n    text-align: center;\n    font-family: Inter;\n    font-size: 50px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.champion-box{\n    width: 123px;\n    height: 118px;\n    border-radius: var(--1, 8px) var(--1, 8px) var(--none, 0px) var(--none, 0px);\n    border-top: 1px solid #6D6D6D;\n    border-right: 1px solid #6D6D6D;\n    border-left: 1px solid #6D6D6D;\n    background: #FFF;\n}\n\n.place-holder-team{\n    border-radius: 2px;\n    background: #B3B3B3;\n    width: 89px;\n    height: 89px;\n    margin: 0 auto;\n    margin-top: 15px;\n}\n\n.champion-title{\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    border-radius: var(--none, 0px) var(--none, 0px) var(--1, 8px) var(--1, 8px);\n    border-right: 1px solid #6D6D6D;\n    border-bottom: 1px solid #6D6D6D;\n    border-left: 1px solid #6D6D6D;\n    background: #F2F2F2;\n    display: flex;\n    width: 123px;\n    height: 29.4px;\n    padding: var(--1, 8px);\n    justify-content: center;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n}\n\n.tournament-bracket {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n    grid-gap: 20px; // Adjust the gap as needed\n    position: relative; // For positioning the center piece\n\n    .bracket-quadrant-left-top {\n        grid-area: 1 / 1 / 2 / 2; // Moved to top left\n\n    }\n\n    .bracket-quadrant-right-top {\n        grid-area: 1 / 2 / 2 / 3; // Moved to top right\n    }\n    // .bracket-quadrant-right-top .bracket .round .bracket-box .team-selection .team-selection {\n    //     flex-direction: row-reverse;\n\n    //     input{\n    //         margin-right: 55px;\n    //         // margin:0 7px 0 auto;\n    //     }\n    // }\n\n    .bracket-quadrant-right-top .bracket{\n        flex-direction: row-reverse;\n    }\n\n    .bracket-quadrant-left-bottom {\n        grid-area: 2 / 1 / 3 / 2; // Moved to bottom left\n    }\n\n    .bracket-quadrant-right-bottom {\n        grid-area: 2 / 2 / 3 / 3; // Moved to bottom right\n        // display: flex;\n        // flex-direction: row-reverse;\n\n    }\n    .bracket-quadrant-right-bottom .bracket{\n        flex-direction: row-reverse;\n    }\n\n    // .bracket-quadrant-left-bottom .bracket .bracket-column-3 .line-beginning{\n    //     width: 16px;\n    //     // border-bottom: 1px solid #6D6D6D;\n    //     // height: 46px;\n    // }\n    .bracket-column-3 .line-end{\n        width: 16px;\n        // border-top: 1px solid #6D6D6D;\n        // border-right: 1px solid #6D6D6D;\n        height: 56px;\n        margin-top: 42px;\n    }\n\n    .bracket-column-4 .line-beginning{\n        width: 16px;\n        border-bottom: 1px solid #6D6D6D;\n        height: 46px;\n    }\n    .bracket-column-4 .line-end{\n        width: 16px;\n        border-bottom: 1px solid #6D6D6D;\n        height: 46px;\n    }\n    .final-four {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 1; // Ensure it's above the quadrant items\n    }\n    .bracket-quadrant-right-bottom .bracket{\n        .bracket-column-3 {\n            > div:nth-child(even) .line-end {\n              display:none;\n            }\n            > div:nth-child(even) .line-beginning {\n                width: 16px;\n                border-bottom: 1px solid #6D6D6D;\n                border-left: 1px solid #6D6D6D;\n                height: 56px;\n                margin-top: -87px;           }\n            > div:nth-child(odd) .line-end {\n                display: none;\n            }\n            > div:nth-child(odd) .line-beginning {\n                width: 16px;\n                border-top: 1px solid #6D6D6D;\n                border-left: 1px solid #6D6D6D;\n                height: 56px;\n                margin-top: 21px;\n              }\n            }\n    }\n    .bracket-quadrant-right-top .bracket{\n        .bracket-column-3 {\n            > div:nth-child(even) .line-end {\n              display:none;\n            }\n            > div:nth-child(even) .line-beginning {\n                width: 16px;\n                border-bottom: 1px solid #6D6D6D;\n                border-left: 1px solid #6D6D6D;\n                height: 56px;\n                margin-top: -87px;           }\n            > div:nth-child(odd) .line-end {\n                display: none;\n            }\n            > div:nth-child(odd) .line-beginning {\n                width: 16px;\n                border-top: 1px solid #6D6D6D;\n                border-left: 1px solid #6D6D6D;\n                height: 56px;\n                margin-top: 21px;\n              }\n            }\n    }\n    .bracket-quadrant-left-top .bracket{\n        .bracket-column-3 {\n            > div:nth-child(even) .line-end {\n                width: 16px;\n                border-bottom: 1px solid #6D6D6D;\n                border-right: 1px solid #6D6D6D;\n                height: 56px;\n                margin-top: -87px;\n            }\n            > div:nth-child(even) .line-beginning {\n                display: none;         }\n            > div:nth-child(odd) .line-end {\n                width: 16px;\n                border-top: 1px solid #6D6D6D;\n                border-right: 1px solid #6D6D6D;\n                height: 56px;\n                margin-top: 21px;\n            }\n            > div:nth-child(odd) .line-beginning {\n                display: none;\n              }\n            }\n    }\n    .bracket-quadrant-left-bottom .bracket{\n        .bracket-column-3 {\n            > div:nth-child(even) .line-end {\n                width: 16px;\n                border-bottom: 1px solid #6D6D6D;\n                border-right: 1px solid #6D6D6D;\n                height: 56px;\n                margin-top: -87px;\n            }\n            > div:nth-child(even) .line-beginning {\n                display: none;         }\n            > div:nth-child(odd) .line-end {\n                width: 16px;\n                border-top: 1px solid #6D6D6D;\n                border-right: 1px solid #6D6D6D;\n                height: 56px;\n                margin-top: 21px;\n            }\n            > div:nth-child(odd) .line-beginning {\n                display: none;\n              }\n            }\n    }\n    .bracket-column-6 div{\n        .line-beginning{\n            width: 16px;\n            border-bottom: 1px solid #6D6D6D;\n            height: 0;\n            margin-bottom: 21px;\n\n        }\n        .line-end{\n            width: 16px;\n            border-bottom: 1px solid #6D6D6D;\n            height: 0;\n            margin-bottom: 21px;\n        }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
